const IMAGE_RADIUS_TOKEN_TO_CLASS = {
  brand: 'image-radius--brand',
  none: 'image-radius--none',
  top: 'image-radius--top',
  bottom: 'image-radius--bottom',
  left: 'image-radius--left',
  right: 'image-radius--right',
  'diagonal-left': 'image-radius--diagonal-left',
  'diagonal-right': 'image-radius--diagonal-right',
} as const;

export type ImageRadiusToken = keyof typeof IMAGE_RADIUS_TOKEN_TO_CLASS;

export const resolveImageRadiusToken = (token?: string | null): string => {
  if (!token) {
    return IMAGE_RADIUS_TOKEN_TO_CLASS.brand;
  }

  return (
    IMAGE_RADIUS_TOKEN_TO_CLASS[token as ImageRadiusToken] ??
    IMAGE_RADIUS_TOKEN_TO_CLASS.brand
  );
};
